import { IFeatures } from '../../models/featureFlags';

export const Features: IFeatures = {
    /** Shows push notification */
    EnableNotification: {
        name: 'enableNotificationSettings',
        defaultValue: false,
    },

    /** Shows push notification preview tag */
    DisableNotificationPreview: {
        name: 'disableNotificationPreview',
        defaultValue: false,
    },

    /** Routes notification api to portal */
    EnableNotificationProxy: {
        name: 'apollo-enableNotificationProxy',
        defaultValue: false,
    },

    /** Shows enterprise trial in the app bar if it is on */
    EnableAppBarEnterpriseTrial: {
        name: 'enable-appbar-enterprise-trial',
        defaultValue: false,
    },

    /** Enable Single Session Enforcement */
    EnablePortalShellSingleSession: {
        name: 'enable-portal-shell-single-session',
        defaultValue: false,
    },

    /** Enable Auth */
    EnablePortalShellSelfAuth: {
        name: 'enable-portal-shell-self-auth',
        defaultValue: true,
    },

    /** Enable Local storage overrides for env config fields */
    EnablePortalShellLocalStorageOverrides: {
        name: 'enable-portal-shell-localstorage-overrides',
        defaultValue: false,
    },

    /** Enable using self auth in people picker */
    EnablePortalShellSelfAuthPeoplePicker: {
        name: 'enable-portal-shell-self-auth-people-picker',
        defaultValue: false,
    },

    /** Enable Idle Timeout */
    EnablePortalShellIdleTimeout: {
        name: 'enable-portal-shell-idle-timeout',
        defaultValue: false,
    },

    /** Enable Global Focus */
    EnableGlobalFocus: {
        name: 'enable-global-focus',
        defaultValue: false,
    },

    /** Enable Keys language */
    EnableLocKeysLanguage: {
        name: 'enable-loc-keys-language',
        defaultValue: false,
    },

    /** Enable force parsing the URL for info */
    EnablePortalShellUrlParams: {
        name: 'enable-portal-shell-url-params',
        defaultValue: true,
    },

    /** Enable 48px app-bar */
    EnableAppBarThinner: {
        name: 'enable-appbar-thinner',
        defaultValue: true,
    },

    EnablePeoplePickerIdentityBaseUrlOverride: {
        name: 'apollo-enablePeoplePickerIdentityBaseUrlOverride',
        defaultValue: false,
    },

    EnableAppBarSpacingFix: {
        name: 'apollo-enableAppBarSpacingFix',
        defaultValue: false,
    },
};

export const DefaultValuesMap = Object.values(Features).reduce((accumulator, current) => {
    accumulator[current.name] = current.defaultValue;
    return accumulator;
}, {});
